import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { shareReplay, delay } from 'rxjs/operators';

/**
 * Service de cache
 */
@Injectable({
  providedIn: 'root'
})
export class CacheService {

    private mapCache = new Map<string, ObjetCache>();

    /**
     * Constructeur
     */
    constructor() { }

    /**
     * Obtenir un Observable en cache
     * @param observable
     * @param cle
     * @param duree
     */
    public Obtenir(observable: Observable<any>, cle: string, duree?: number): Observable<any> {
        // R�cup�re l'objet du cache
        const cache = this.mapCache.get(cle);

        // Si l'objet est en cache
        if (cache) {
            // V�rification de la validit�e
            if (this.estValide(cache)) {
                // Objet de cahce valide, retour l'objet
                return of(cache.objet).pipe(delay(1));
            }
            else {
                // Objet de cache non valide, suppression du cache
                this.mapCache.delete(cle);
            }
        }

        // L'observable
        let obs = observable.pipe(shareReplay(1));

        // Dur�e d'expiration
        let dateExpiration: Date = this.obtenirDateExpiration(duree);

        // Mise en cache
        obs.subscribe(retour => this.mapCache.set(cle, { objet: retour, expiration: dateExpiration }));

        // Retour l'observable
        return obs;
    }

    /**
     * Indique si l'objet de cache est valide
     * @param cache
     */
    private estValide(cache: ObjetCache): boolean {
        if (!cache) return false;

        // Pas d'expiration : valide
        if (!cache.expiration) return true;

        // La date d'expiration n'est pas encore atteinte : valide
        return cache.expiration.getTime() > new Date().getTime();
    }

    /**
     * Obtenir la date d'expiration
     * @param duree
     */
    private obtenirDateExpiration(duree?: number): Date {
        let dateExpiration: Date = null;
        if (duree) {
            dateExpiration = new Date();
            dateExpiration.setMilliseconds(dateExpiration.getMilliseconds() + duree);
        }
        return dateExpiration;
    }
}

/**
 * Repr�sente un objet en cache
 */
class ObjetCache {
    expiration?: Date;
    objet: any;
}
